import { Injectable } from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Lista} from "../model/lista";
import {Utiles} from '../pages/utiles/utiles';
// tslint:disable-next-line:quotemark
import {Persona} from "../model/persona";
import {tap} from "rxjs/operators";
import {MotivoRechazoCancelacion} from "../model/motivo-rechazo-cancelacion";

@Injectable()
export class MotivoService {
    private api: string;
    constructor(private http: HttpClient) {
// tslint:disable-next-line:whitespace
        this.api=Utiles.api+'motivoRechazoCancelacion';
    }
    getLista(): Observable<Lista<MotivoRechazoCancelacion>> {

        return this.http.get<Lista<MotivoRechazoCancelacion>>(this.api+'?orderBy='+encodeURI('motivo')+
        '&orderDir='+encodeURI('asc'));
    }

    get(id: number): Observable<MotivoRechazoCancelacion> {
        return this.http.get<MotivoRechazoCancelacion>(this.api+'/'+id);
    }

    agregar(p: MotivoRechazoCancelacion): Observable<MotivoRechazoCancelacion>{
        return this.http.post<MotivoRechazoCancelacion>(this.api,p)
            .pipe(
                tap(
                    data => console.log('agregado: '+data),
                    error => console.log('error: '+error)
                ));
    }

    modificar(p: MotivoRechazoCancelacion): Observable<MotivoRechazoCancelacion>{
        return this.http.put<MotivoRechazoCancelacion>(this.api, p)
            .pipe(
                tap(
                    data => console.log('agregado: '+data),
                    error => console.log('error: '+error)
                ));
    }

    eliminar(id: number): Observable<{}>{

        return this.http.delete(this.api+'/'+id)
            .pipe(
                tap(
                    data => console.log('eliminado'),
                    error => console.log('eliminado'),
                ));


    }
}
